import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NO_VALUE } from '@pipes';
import { HeatingConfigurationRegulationMode } from '@vi-iot/client/apis/operational-data/operational-data.model';

@Pipe({
  name: 'heatingConfigurationRegulationType',
})
export class HeatingConfigurationRegulationTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(input: string): unknown {
    switch (input) {
      case HeatingConfigurationRegulationMode.Nothing:
        return this.translate.instant('TI_Nothing');
      case HeatingConfigurationRegulationMode.ConstantControlled:
        return this.translate.instant('TI_ConstantControlled');
      case HeatingConfigurationRegulationMode.DeltaTControlled:
        return this.translate.instant('TI_DeltaTControlled');
      case HeatingConfigurationRegulationMode.RoomControlled:
        return this.translate.instant('TI_RoomControlled');
      case HeatingConfigurationRegulationMode.WeatherByOutsideSensorControlled:
        return this.translate.instant('TI_WeatherByOutsideSensorControlled');
      case HeatingConfigurationRegulationMode.WeatherByRemoteOutsideSensorControlled:
        return this.translate.instant('TI_WeatherByRemoteOutsideSensorControlled');
      case HeatingConfigurationRegulationMode.WeatherByServiceControlled:
        return this.translate.instant('TI_WeatherByServiceControlled');
      case HeatingConfigurationRegulationMode.WeatherByOutsideSensorAndRoomCorrectionControlled:
        return this.translate.instant('TI_WeatherByOutsideSensorAndRoomCorrectionControlled');
      case HeatingConfigurationRegulationMode.WeatherByRemoteOutsideSensorAndRoomCorrectionControlled:
        return this.translate.instant('TI_WeatherByRemoteOutsideSensorAndRoomCorrectionControlled');
      case HeatingConfigurationRegulationMode.WeatherByServiceAndRoomCorrectionControlled:
        return this.translate.instant('TI_WeatherByServiceAndRoomCorrectionControlled');
      case HeatingConfigurationRegulationMode.ConstantControlledWithExternalThermostat:
        return this.translate.instant('TI_ConstantControlledWithExternalThermostat');
      case HeatingConfigurationRegulationMode.WeatherByOutsideSensorWithExternalThermostat:
        return this.translate.instant('TI_WeatherByOutsideSensorWithExternalThermostat');
      case HeatingConfigurationRegulationMode.WeatherByOutsideSensorRoomByRoom:
        return this.translate.instant('TI_WeatherByOutsideSensorRoomByRoom');
      case HeatingConfigurationRegulationMode.BasicConstantFlowControl:
        return this.translate.instant('TI_BasicConstantFlowControl');
      case HeatingConfigurationRegulationMode.ConstantFlowControlOpenTherm:
        return this.translate.instant('TI_ConstantFlowControlOpenTherm');
      case HeatingConfigurationRegulationMode.DeltaTRoomOnOff:
        return this.translate.instant('TI_DeltaTRoomOnOff');
      case HeatingConfigurationRegulationMode.DeltaTRoomModulation:
        return this.translate.instant('TI_DeltaTRoomModulation');
      case HeatingConfigurationRegulationMode.DeltaTRoomWithWeatherForeCast:
        return this.translate.instant('TI_DeltaTRoomWithWeaterhForeCast');
      default:
        return NO_VALUE;
    }
  }
}
